import { render } from "./OutstandingTransactionList.vue?vue&type=template&id=4862f979"
import script from "./OutstandingTransactionList.vue?vue&type=script&lang=js"
export * from "./OutstandingTransactionList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mattday/Sites/swallowdental.co.uk/app/code/SwallowDental/CustomAccount/view/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"web/vue/components/OutstandingTransactionList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4862f979"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4862f979', __exports__)) {
    api.reload('4862f979', __exports__)
  }
  
  module.hot.accept("./OutstandingTransactionList.vue?vue&type=template&id=4862f979", () => {
    api.rerender('4862f979', render)
  })

}


export default __exports__